import { createStore } from "vuex";
import { auth } from "./auth.module";

import { terminology } from "./terminology.module";
import { fetch } from "./fetch.module";
import { Fonts } from "./fonts.module";

export default createStore({
  state: {},
  mutations: {},
  actions: {},
  modules: {
    auth,
    fetch,
    terminology,
    Fonts,
    // customer: fetch,
    // employee: fetch,
    // vendor: fetch,
    // account: fetch,
  },
});
